import {createContext} from 'react';

const cuotaContext = createContext() 
 
export default cuotaContext;